/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Moment
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
Vue.use(VueMoment, { moment })
Vue.use(Datetime)

// Offline
Vue.component('VOffline', require('v-offline'))
import VueOffline from 'vue-offline'
Vue.use(VueOffline, { mixin: false })

import VueParticles from 'vue-particles'
Vue.use(VueParticles)


// HTTP Plugin
import axios from './axios.js'
Vue.prototype.$http = axios
if (localStorage.getItem('accessToken')) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('accessToken')
}
Vue.prototype.$http.interceptors.response.use((response) => { return response }, (error) => {
  if (error.response.status === 401 && parseInt(localStorage.getItem('exp')) < moment().format('x')) {
    window.location.href = '/login'
    return
  }
  return Promise.reject(error)
})

// API Calls
import './http/requests'

// Service Worker
const prod = process.env.NODE_ENV === 'production'
const shouldSW = 'serviceWorker' in navigator && prod
if (shouldSW) {
  navigator.serviceWorker.register('/sw.js')
    .then((reg) => {
      // reg.installing // installing worker, or undefined
      // reg.waiting    // waiting worker, or undefined
      // reg.active     // active worker, or undefined
      console.log('sw registered')

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing

        // newWorker.state
        // "installing" - the install event has fired, but not yet complete
        // "installed"  - install complete
        // "activating" - the activate event has fired, but not yet complete
        // "activated"  - fully active
        // "redundant"  - discarded. Either failed install, or it's been replaced by a newer version

        newWorker.addEventListener('statechange', () => {
          switch (newWorker.state) {
          case 'installed':
            if (navigator.serviceWorker.controller) {
              console.log('installed')
              // newWorker.postMessage({ action: 'skipWaiting' })
            }
            break
          }
        })
      })

      function promptUserToRefresh () {
        if (confirm('Refresh now?')) {
          reg.waiting.skipWaiting()
        }
      }

      if (reg.waiting) promptUserToRefresh()
      reg.addEventListener('statechange', (e) => {
        if (e.target.state === 'installed') {
          promptUserToRefresh()
        } else if (e.target.state === 'activated') {
          window.location.reload()
        }
      })
    })
    .catch(err => console.error('[SW ERROR]', err.message))
}

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'

// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

// ACL
// import acl from './acl/acl'

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')


// Vue Loading
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
Vue.use(Loading)

// Alert
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
Vue.use(VueSweetalert2)


// Vue select css
import 'vue-select/dist/vue-select.css'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

// Highcharts
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import highchartsMore from 'highcharts/highcharts-more'
highchartsMore(Highcharts)
import exportingInit from 'highcharts/modules/exporting'
exportingInit(Highcharts)
Vue.use(HighchartsVue)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  acl,
  render: h => h(App)
}).$mount('#app')
